import axios from 'axios';

// Same-origin by default (nginx proxies /api -> backend). Override only for split hosting.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Hotels
export const fetchHotels = (params = {}) => api.get('/hotels', { params }).then((r) => r.data);
export const fetchHotelFilters = () => api.get('/hotels/filters').then((r) => r.data);

// Emirates / FAQs
export const fetchEmirates = () => api.get('/emirates').then((r) => r.data);
export const fetchFaqs = (page) => api.get('/faqs', { params: { page } }).then((r) => r.data);

// Newsletter
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then((r) => r.data);

// Itinerary
export const fetchItinerary = (sid) => api.get(`/itinerary/${sid}`).then((r) => r.data);
export const addItineraryItem = (sid, item) => api.post(`/itinerary/${sid}`, item).then((r) => r.data);
export const removeItineraryItem = (sid, itemId) => api.delete(`/itinerary/${sid}/${itemId}`).then((r) => r.data);

// ---- Admin ----
function authHeader(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const adminLogin = (username, password) =>
  api.post('/admin/login', { username, password }).then((r) => r.data);
export const adminMe = (token) => api.get('/admin/me', authHeader(token)).then((r) => r.data);

export const adminGetHotels = (token) => api.get('/admin/hotels', authHeader(token)).then((r) => r.data);
export const adminCreateHotel = (token, data) => api.post('/admin/hotels', data, authHeader(token)).then((r) => r.data);
export const adminUpdateHotel = (token, id, data) => api.put(`/admin/hotels/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteHotel = (token, id) => api.delete(`/admin/hotels/${id}`, authHeader(token)).then((r) => r.data);

export const adminGetFaqs = (token) => api.get('/admin/faqs', authHeader(token)).then((r) => r.data);
export const adminCreateFaq = (token, data) => api.post('/admin/faqs', data, authHeader(token)).then((r) => r.data);
export const adminUpdateFaq = (token, id, data) => api.put(`/admin/faqs/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteFaq = (token, id) => api.delete(`/admin/faqs/${id}`, authHeader(token)).then((r) => r.data);

export const adminGetEmirates = (token) => api.get('/admin/emirates', authHeader(token)).then((r) => r.data);
export const adminCreateEmirate = (token, data) => api.post('/admin/emirates', data, authHeader(token)).then((r) => r.data);
export const adminUpdateEmirate = (token, slug, data) => api.put(`/admin/emirates/${slug}`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteEmirate = (token, slug) => api.delete(`/admin/emirates/${slug}`, authHeader(token)).then((r) => r.data);

export const adminChangePassword = (token, current_password, new_password) =>
  api.post('/admin/change-password', { current_password, new_password }, authHeader(token)).then((r) => r.data);
export const adminGetNewsletter = (token) => api.get('/admin/newsletter', authHeader(token)).then((r) => r.data);

// ---- Trip schedule (day-by-day) ----
export const fetchSchedule = (sid) => api.get(`/schedule/${sid}`).then((r) => r.data);
export const saveSchedule = (sid, days) => api.put(`/schedule/${sid}`, { days }).then((r) => r.data);

// ---- Monetization ----
export const fetchMonetization = () => api.get('/monetization').then((r) => r.data);
export const fetchDeals = () => api.get('/deals').then((r) => r.data);
export const submitLead = (data) => api.post('/leads', data).then((r) => r.data);

export const adminGetMonetization = (token) => api.get('/admin/monetization', authHeader(token)).then((r) => r.data);
export const adminUpdateMonetization = (token, data) => api.put('/admin/monetization', data, authHeader(token)).then((r) => r.data);
export const adminGetAffiliates = (token) => api.get('/admin/affiliates', authHeader(token)).then((r) => r.data);
export const adminCreateAffiliate = (token, data) => api.post('/admin/affiliates', data, authHeader(token)).then((r) => r.data);
export const adminUpdateAffiliate = (token, id, data) => api.put(`/admin/affiliates/${id}`, data, authHeader(token)).then((r) => r.data);
export const adminDeleteAffiliate = (token, id) => api.delete(`/admin/affiliates/${id}`, authHeader(token)).then((r) => r.data);
export const adminGetLeads = (token) => api.get('/admin/leads', authHeader(token)).then((r) => r.data);
export const adminDeleteLead = (token, id) => api.delete(`/admin/leads/${id}`, authHeader(token)).then((r) => r.data);

// ---- Affiliate click tracking ----
export const trackAffiliateClick = (id) => api.post(`/affiliates/${id}/click`).then((r) => r.data).catch(() => {});
export const adminGetAffiliateClicks = (token) => api.get('/admin/affiliate-clicks', authHeader(token)).then((r) => r.data);
